import dealers from './dealers';

export default function* () {
    yield* [
        ...dealers
    ];
}
